import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

// React console warns against managed inputs with no onChange
// handlers. Since we are toggling on label click, we don't need
// an onChange handler on the input, so just call no operation.
const NOOP = () => {};

export default class Checkbox extends React.Component {
  static propTypes = {
    checked: PropTypes.bool,
    containerClass: PropTypes.string,
    containerStyle: PropTypes.object,
    // dumb grants state control to parent component via props
    dumb: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onDeselect: PropTypes.func,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    checked: false,
    containerClass: '',
    containerStyle: {},
    dumb: false,
    label: '',
    onDeselect: () => {},
    onSelect: () => {},
  };

  constructor(props) {
    super();
    if (!props.dumb) {
      const checked = props.checked || false;
      this.state = {checked};
    }
    this.toggle = this.toggle.bind(this);
  }

  toggle(name) {
    const checked = this.props.dumb ? !this.props.checked : !this.state.checked;

    if (checked) {
      this.props.onSelect(name);
    } else {
      this.props.onDeselect(name);
    }

    if (!this.props.dumb) {
      this.setState({checked});
    }
  }

  render() {
    const {containerClass, containerStyle, label, name} = this.props;

    const checked = this.props.dumb ? this.props.checked : this.state.checked;

    return (
      <div
        className={`Checkbox-container ${containerClass}`}
        style={containerStyle}>
        <input
          checked={checked}
          className={'Checkbox'}
          id={`id_${name}`}
          name={name}
          onChange={NOOP}
          type={'checkbox'}
        />

        <label
          className={'Checkbox-label'}
          htmlFor={`id-${name}`}
          onClick={this.toggle.bind(this, name)}>
          {label}
        </label>
      </div>
    );
  }
}
